/* eslint-disable no-param-reassign */
import { createAction, createReducer } from '@reduxjs/toolkit';
import {get} from "lodash-es";

const Actions = {
	setDefaultOrderFormData: 'setDefaultOrderFormData',
};

// actions
export const setDefaultOrderFormData = createAction(Actions.setDefaultOrderFormData);

// Selectors
export const getDefaultOrderFormTab = (state) => {
	return get(state, 'equityGlobal.defaultOrderFormData.productType', '');
};

export const getDefaultOrderType = (state) => {
	return get(state, 'equityGlobal.defaultOrderFormData.orderType', '');
};

// initialState
const initialState = {
	defaultOrderFormData: {},
};

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setDefaultOrderFormData, (state, action) => {
		state.defaultOrderFormData = { ...state.defaultOrderFormData, ...action.payload };
	});
});
